import { Card, Empty } from 'antd';
import React from 'react';
import { useLocation } from 'react-router-dom';

const NoticeDetails = () => {
  const { state } = useLocation();
  const notice = state?.notice;

  if (!notice) return <Empty />;

  return (
    <Card title={notice.text}>
      {notice.files?.length ? (
        notice.files.map((link, index) => (
          <div key={link + index} style={{ marginBottom: 8 }}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {index + 1}. {notice.text} {notice.files.length > 1 ? `(Link-${index + 1})` : ""}
            </a>
          </div>
        ))
      ) : (
        <Empty />
      )}
    </Card>
  );
};

export default NoticeDetails;